<template>
  <div>
    <!-- style="color: #3d4d6b; width: 440px; margin: 10px auto 0 auto" -->
    <div class="inviteBody">
      <ul
        style="
          text-align: center;
          padding: 20px;
          font-size: 18px;
          color: #11254a;
        "
      >
        <li>{{ $t('component.EditUser.pageTitle') }}</li>
      </ul>
      <ul class="invite-content">
        <li style="text-align: center; padding: 10px">
          <div class="img_fit">
            <img :src="pictureBase64" />
          </div>
        </li>
        <li style="text-align: center">
          <a-button
            :loading="uloading"
            type="primary"
            style="
              height: 38px;
              background: #395489;
              border-color: #2ca70e;
              width: 170px;
            "
            v-on:click="selectPic()"
            >{{ $t('component.EditUser.uploadPic') }}</a-button
          >
          <input
            type="file"
            id="files"
            ref="refFile"
            accept="image/jpeg,image/jpg,image/png,image/gif"
            style="display: none"
            v-on:change="fileLoad()"
          />
        </li>
        <li style="text-align: center; padding: 10px">
          {{ shopOrmerchantName }}
        </li>
        <li style="text-align: center; padding: 10px">{{ userEmail }}</li>
        <li>
          <div>
            <ul>
              <!-- style="
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-around;
                " -->
              <!-- style ="margin-bottom: 10px;
                  display: flex;
                  justify-content: space-around;" -->
              <!-- class="nameInputBox" -->
              <li class="nameInputBox">
                <!-- style="border: 0; flex: 0 0 47%; height: 39px" -->
                <a-input
                  v-model:value="firstName"
                  :placeholder="$t('component.EditUser.firstName')"
                ></a-input>
                <div style="flex: 0 0 47%">
                  <!-- style="border: 0; flex: 0 0 47%; height: 39px" -->
                  <a-input
                    v-model:value="lastName"
                    :placeholder="$t('component.EditUser.lastName')"
                  ></a-input>
                </div>
              </li>
            </ul>
            <ul>
              <!-- style="
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-around;
                " -->
              <li class="mrphoneBox">
                <!-- <a-input v-model:value="salutation" :placeholder="$t('component.EditUser.salutation')" style="border: 0; flex: 0 0 47%; height: 40px"></a-input> -->
                <div style="flex: 0 0 47%">
                  <a-select
                    v-model:value="salutation"
                    default-value="Mr"
                    style="margin-right: 5px; width: 100%"
                    :size="size"
                  >
                    <a-select-option
                      v-for="item in SalutationList"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div style="flex: 0 0 47%">
                  <!-- style="width: 71px; margin-right: 5px; font-size: 12px"  phoneCodeSelect-->
                  <a-select
                    v-model:value="phoneValue"
                    default-value="+852"
                    class="countryCodeSelect"
                    :size="size"
                  >
                    <a-select-option
                      v-for="item in CountryCodeList"
                      :key="item.code"
                    >
                      {{ item.code }}
                    </a-select-option>
                  </a-select>
                  <!-- style="border: 0; width: 62%; height: 40px"  phoneNumInput-->
                  <a-input
                    v-model:value="phone"
                    :placeholder="$t('component.EditUser.phone')"
                    class="phoneNumInput"
                  ></a-input>
                </div>
              </li>
            </ul>
            <ul>
              <!-- style="
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-around; userTitleBox
                " -->
              <li class="userTitleBox">
                <!-- style="border: 0; flex: 0 0 47%; height: 39px" -->
                <a-input
                  v-model:value="title"
                  :placeholder="$t('component.EditUser.title')"
                >
                </a-input>
                <div style="flex: 0 0 47%">
                  <!-- style="width: 71px; margin-right: 5px; font-size: 12px" countryCodeSelect-->
                  <a-select
                    class="countryCodeSelect"
                    :size="size"
                    v-model:value="mobileValue"
                    default-value="+852"
                  >
                    <a-select-option
                      v-for="item in CountryCodeList"
                      :key="item.code"
                    >
                      {{ item.code }}
                    </a-select-option>
                  </a-select>
                  <!-- style="border: 0; width: 62%; height: 39px" -->
                  <a-input
                    v-model:value="mobile"
                    :placeholder="$t('component.EditUser.mobile')"
                    class="mobileInput"
                  ></a-input>
                </div>
              </li>
            </ul>
            <ul>
              <!-- style="margin-bottom: 10px; display: flex;j;padding-left: 6px;" -->
              <li class="faxBox">
                <div style="flex: 0 0 49%">
                  <!-- style="width: 71px; margin-right: 5px; font-size: 12px" -->
                  <a-select
                    :size="size"
                    v-model:value="faxCountryCode"
                    default-value="+852"
                    class="countryCodeSelect"
                  >
                    <a-select-option
                      v-for="item in CountryCodeList"
                      :key="item.code"
                    >
                      {{ item.code }}
                    </a-select-option>
                  </a-select>
                  <!-- style="border: 0; width: 62%; height: 39px" faxInput-->
                  <a-input
                    v-model:value="faxValue"
                    :placeholder="$t('component.EditUser.fax')"
                    class="faxInput"
                  ></a-input>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li style="text-align: center; padding: 15px">
          <a-checkbox v-model:checked="receiveDailySummaryEmail">{{
            $t('component.EditUser.receiveUsageReport')
          }}</a-checkbox>
        </li>
      </ul>
    </div>

    <div style="text-align: center; padding-top: 20px">
      <a-button
        :loading="loading"
        type="primary"
        style="
          height: 38px;
          background: #2ca70e;
          border-color: #2ca70e;
          width: 200px;
        "
        class="saveBtn"
        v-on:click="updateProfile()"
        >{{ $t('component.EditUser.save') }}</a-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditUser',
  data() {
    return {
      size: 'large',
      firstName: '',
      lastName: '',
      salutation: '',
      phone: '',
      title: '',
      mobile: '',
      phoneValue: '',
      mobileValue: '',
      userEmail: '',
      shopOrmerchantName: '',
      receiveDailySummaryEmail: true,
      loading: false,
      uloading: false,
      CountryCodeList: '',
      SalutationList: '',
      faxCountryCode: '',
      faxValue: ''
    };
  },
  created() {
    let t1 = this.$store.getters.get_CountryCode_cache;
    this.CountryCodeList = t1;
    this.SalutationList = [
      { id: 1, name: 'Mr' },
      { id: 2, name: 'Mrs' },
      { id: 3, name: 'Miss' },
      { id: 4, name: 'Ms' },
      { id: 5, name: this.$t('component.EditUser.salutationNonDisclosure') }
    ];
    this.salutation = 'Mr';
  },
  methods: {
    selectPic() {
      this.$refs.refFile.click();
    },
    fileLoad() {
      const selectedFile = this.$refs.refFile.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onload = (event) => {
        var imageSrc = event.target.result;
        var image = new Image();
        image.onload = () => {
          var width = image.width;
          var height = image.height;

          if (width > 128 || height > 128) {
            if (width >= height) {
              this.dealImage(
                imageSrc,
                width,
                height,
                {
                  width: 128,
                  quality: 1
                },
                (base) => {
                  this.uploadPic(base);
                }
              );
            } else {
              this.dealImage(
                imageSrc,
                width,
                height,
                {
                  height: 128,
                  quality: 1
                },
                (base) => {
                  this.uploadPic(base);
                }
              );
            }
          } else {
            this.dealImage(
              imageSrc,
              width,
              height,
              {
                width: width,
                quality: 1
              },
              (base) => {
                this.uploadPic(base);
              }
            );
          }
        };
        image.src = imageSrc;
      };
    },
    dealImage(path, width, height, obj, callback) {
      let ts = this;
      var img = new Image();
      img.src = path;
      img.onload = function () {
        var that = this;
        // 默认按比例压缩
        var w = width,
          h = height,
          scale = w / h;
        w = obj.width || obj.height * scale;
        h = obj.height || obj.width / scale;
        var quality = 0.7; // 默认图片质量为0.7
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute('width');
        anw.nodeValue = w;
        ts.rw = w;
        var anh = document.createAttribute('height');
        anh.nodeValue = h;
        ts.rh = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        callback(base64);
      };
    },
    uploadPic(basePic) {
      this.$store.dispatch('setServerpictureBase64', basePic);
      //this.globalCache.user.pictureBase64 = basePic;
      let user = this.$store.getters.get_user_Info_cache;
      if (!user) {
        return;
      } else {
        user.pictureBase64 = encodeURIComponent(basePic);
      }
      let self = this;
      self.uloading = true;
      this.$axios
        .post('/user/profilePic', user)
        .then(() => {
          self.uloading = false;
          //alert("upload picture success")
        })
        .catch((err) => {
          self.uloading = false;
          //alert("upload picture error: " + err)
          console.error(err);
        });
    },
    updateProfile() {
      if (!this.firstName || !this.lastName) {
        this.$message.info(
          this.$t('component.EditUser.firstLastNameCannotEmpty')
        );
        return;
      }
      let self = this;
      self.loading = true;
      let user = this.$store.getters.get_user_Info_cache;
      if (user) {
        user.firstName = this.firstName;
        user.lastName = this.lastName;
        user.salutation = this.salutation;
        //  let sal=this.SalutationList.find(p=>p.id==this.salutation);
        //  user.salutation=sal.name;
        user.title = this.title;
        user.phoneNumber = this.phone;
        user.phoneCountryCode = this.phoneValue;
        user.mobileNumber = this.mobile;
        user.mobileCountryCode = this.mobileValue;
        user.receiveDailySummaryEmail = this.receiveDailySummaryEmail;
        user.faxCountryCode = this.faxCountryCode;
        user.fax = this.faxValue;

        this.$axios
          .post('/User', user)
          .then(function (res) {
            self.loading = false;
            if (res) {
              self.$store.dispatch('setuserInfocache', user);
              self.$router.push('/UserInfo/EditingUser');
            }
          })
          .catch(() => {
            self.loading = false;
          });
      }
    }
  },
  computed: {
    pictureBase64: function () {
      return this.$store.state.picture_Base64;
    }
  },
  mounted() {
    let user = this.$store.getters.get_user_Info_cache;
    if (user) {
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.salutation = user.salutation;
      this.phone = user.phoneNumber;
      this.mobile = user.mobileNumber;
      this.title = user.title;
      this.phoneValue = user.phoneCountryCode;
      if (!this.phoneValue) this.phoneValue = '+852';

      this.mobileValue = user.mobileCountryCode;
      if (!this.mobileValue) this.mobileValue = '+852';

      this.shopOrmerchantName = user.isMerchant
        ? user.merchantName
        : user.shopName;
      this.userEmail = user.id;
      this.faxCountryCode = user.faxCountryCode;
      if (!this.faxCountryCode) this.faxCountryCode = '+852';

      this.faxValue = user.fax;
      this.receiveDailySummaryEmail = user.receiveDailySummaryEmail;
    }
  }
};
</script>

<style scoped>
.inviteBody {
  color: #3d4d6b;
  width: 440px;
  margin: 10px auto 0 auto;
}

.invite-content {
  background-color: #c6cbd1;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
}

.img_fit {
  width: 80px;
  height: 78px;
  margin: 0 auto;
}

.img_fit img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nameInputBox {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
}

.nameInputBox > input,
.nameInputBox > div > input {
  border: 0px;
  flex: 0 0 47%;
  height: 39px;
}
.mrphoneBox {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
}
.phoneCodeSelect {
  width: 71px;
  margin-right: 5px;
  font-size: 12px;
}
.phoneNumInput {
  border: 0;
  width: 62%;
  height: 40px;
}
.userTitleBox {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
}
.userTitleBox > input {
  border: 0;
  flex: 0 0 47%;
  height: 39px;
}
.countryCodeSelect {
  width: 71px;
  margin-right: 5px;
  font-size: 12px;
}
.mobileInput {
  border: 0;
  width: 62%;
  height: 39px;
}
.faxBox {
  margin-bottom: 10px;
  display: flex;
  padding-left: 6px;
}
.faxInput {
  border: 0;
  width: 62%;
  height: 39px;
}

/* @media (max-width: 1240px) {
} */

@media (max-width: 420px) {
  .inviteBody {
    width: 300px;
  }
  .nameInputBox {
    flex-direction: column;
    align-items: inherit;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 0px;
  }
  .nameInputBox input,
  .nameInputBox > div > input[data-v-a15352b6] {
    border: 0px;
    flex: none;
    height: 40px;
    margin-bottom: 10px;
  }

  .mrphoneBox {
    flex-direction: column;
    align-items: inherit;
    margin: 0px 10px 10px 10px;
  }
  .phoneCodeSelect {
    width: 95px;
    margin-top: 10px;
  }
  .phoneNumInput {
    width: 64%;
    height: 40px;
    margin-top: 10px;
  }
  .userTitleBox {
    flex-direction: column;
    align-items: inherit;
    margin: 0px 10px 0px 10px;
  }
  .userTitleBox > input {
    flex: none;
    height: 40px;
  }
  .countryCodeSelect {
    width: 95px;
    margin-top: 10px;
  }
  .mobileInput {
    width: 64%;
    height: 40px;
    margin-top: 10px;
  }
  .faxBox {
    flex-direction: column;
    align-items: inherit;
    margin: 0px 10px 5px 5px;
  }
  .faxInput {
    width: 64%;
    height: 40px;
    margin-top: 10px;
  }
  .saveBtn {
    margin-bottom: 20px;
  }
}
</style>
